import { Image, Modal, Row, Col, Button, Spin } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getImagePath } from "../../../../utils/getImagePath";
import { DownloadOutlined, AliwangwangOutlined } from "@ant-design/icons";
import useAxios from "axios-hooks";
import { Resource } from "../../../../api/common";

interface IProps {
   visible: boolean;
   onCancel: () => any;
   requestData?: any;
}

export const OrderDetailsModal = ({
   visible,
   onCancel,
   requestData
}: IProps) => {
   const [t] = useTranslation();
   const [selectedItems, setSelectedItems] = useState([]);
   const [orderData, setOrderData] = useState<any>(null);

   useEffect(() => {
      getOrderDetails();
   }, [requestData.order_id]);

   const [{ data: orderDatailsData }, getOrderDetails] = useAxios(
      {
         url: `${Resource.path.orderDetails(requestData.order_id)}`,
         method: "GET"
      },
      { manual: true }
   );

   useEffect(() => {
      setSelectedItems(orderDatailsData?.data?.requestData);
      setOrderData(orderDatailsData?.data?.orderData);
   }, [orderDatailsData]);

   const [deliveryAddress, setDeliveryAddress] = useState({
      street: "",
      zip: "",
      city: ""
   });

   const [invoiceAddress, setInvoiceAddress] = useState({
      company: "",
      street: "",
      zip: "",
      city: ""
   });

   const [contactDetails, setContactDetails] = useState({
      firstName: "",
      lastName: "",
      phone: "",
      email: ""
   });

   useEffect(() => {
      orderData?.delivery_address &&
         setDeliveryAddress(
            JSON.parse(orderDatailsData.data.orderData.delivery_address)
         );
      orderData?.invoice_address &&
         setInvoiceAddress(
            JSON.parse(orderDatailsData.data.orderData.invoice_address)
         );
      orderData?.contact_details &&
         setContactDetails(
            JSON.parse(orderDatailsData.data.orderData.contact_details)
         );
   }, [orderData]);

   const totalPieces = () => {
      return selectedItems
         .reduce((a: any, b: { [x: string]: any }) => a + (b["amount"] || 0), 0)
         .toLocaleString();
   };

   const getPrice = (item: any) => {
      /*       let deconstructionCost = 0;
      if (
         item?.deconstructability &&
         item?.deconstructability === "loose (easy)"
      ) {
         console.log("CASE-1");
         deconstructionCost = 1;
      } else if (
         item?.deconstructability &&
         [
            "built-in (easy)",
            "built-in (moderate)",
            "built-in (elaborate)"
         ].indexOf(item?.deconstructability) !== -1 &&
         item?.third_party_deconstruction
      ) {
         deconstructionCost = 1;
         console.log("CASE-2");
      } else {
         deconstructionCost = 0;
      }
      console.log(item, deconstructionCost);
      return (
         (item?.selling_price -
            ((item.demands_target_price ? item.demands_target_price : 0) -
               item.deconstruction_costs * deconstructionCost)) *
         item.amount
      ); */
      let deconstructionCost = 0;
      if (item.deconstruction_type === "provided") {
         deconstructionCost = 1;
      }
      //console.log('selectedItems', selectedItems);
      return (
         item?.selling_price * item.amount +
         (item.deconstruction_costs || item.pg_deconstruction_costs) *
            deconstructionCost *
            item.amount
      );
   };

   const getTotalPrice = () => {
      const items_price = selectedItems.map(
         (item: any) => (item.price = getPrice(item))
      );
      return items_price.length ? items_price.reduce((a, b) => a + b, 0) : 0;
   };

   const download = () => {
      document.querySelector("#printSection")?.remove();
      printElement(document.getElementById("printElement"));
      window.print();
   };

   function printElement(elem: any) {
      const domClone = elem.cloneNode(true);

      let printSection = document.getElementById("printSection");

      if (!printSection) {
         printSection = document.createElement("div");
         printSection.id = "printSection";
         document.body.appendChild(printSection);
      }
      printSection.innerHTML = "";
      printSection.appendChild(domClone);
   }

   return (
      <Modal visible={visible} width={1200} onCancel={onCancel} footer={null}>
         <Spin spinning={!orderData}>
            <div className="requestform" id="printElement">
               <div className="header">
                  <h3 className="title">
                     {t("passportDetails.request")} {`#${orderData?.id}`}
                  </h3>
                  <div className="buttons">
                     <Button
                        type="link"
                        icon={<DownloadOutlined />}
                        onClick={() => download()}
                     >
                        {t("default.download")}
                     </Button>
                     <Button
                        type="link"
                        className="contact"
                        icon={<AliwangwangOutlined />}
                     >
                        {t("default.contactSupport")}
                     </Button>
                  </div>
               </div>
               <Row
                  gutter={24}
                  justify="space-between"
                  className="material-info"
               >
                  <Col span={2} className="material-image">
                     <Image
                        src={
                           requestData?.images
                              ? getImagePath(requestData.images[0])
                              : "error"
                        }
                        key={requestData.id}
                        fallback="data:image/png;base64,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"
                     />
                  </Col>
                  <Col span={22} className="products">
                     <h3 className="title">
                        {orderData?.manufacturer} {requestData.product_name}
                     </h3>
                     <div className="material-list">
                        {orderDatailsData &&
                           orderDatailsData.data.requestData.map(
                              (item: any, index: number) => {
                                 return (
                                    <div className="cluster-row">
                                       <Row
                                          gutter={24}
                                          className="requested-passport"
                                       >
                                          <Col span={7}>
                                             <div className="bold-title">{`${t(
                                                "passportDetails.condition"
                                             )}: ${item.condition}`}</div>
                                          </Col>
                                          <Col span={8}>
                                             <div className="bold-title">
                                                {`${item.deconstructability}`}
                                             </div>
                                             <div className="subtitle">
                                                {item.deconstructability.includes(
                                                   "loose"
                                                )
                                                   ? t(
                                                        "passportDetails.noDeconstructionNeeded"
                                                     )
                                                   : ""}
                                             </div>
                                          </Col>
                                          <Col
                                             span={6}
                                             className="display-flex pieces"
                                          >
                                             <div className="available-pieces">
                                                <span>{item?.amount}</span>
                                                <span>
                                                   {item?.amount_unit == "Stück"
                                                      ? t("demands.pieces")
                                                      : item?.amount_unit}
                                                </span>
                                             </div>
                                          </Col>
                                          <Col
                                             span={3}
                                             className="display-flex item-price justify-end"
                                          >
                                             <span className="price">{`${getPrice(
                                                item
                                             ).toLocaleString()} €`}</span>{" "}
                                          </Col>
                                       </Row>
                                       {/* {item?.data?.operations_id !=
                                    selectedItems[index + 1]?.data
                                       ?.operations_id && ( */}
                                       <Row className="deconst-info fix">
                                          <Col
                                             span={9}
                                             className={
                                                item.deconstruction_type
                                                   ? ""
                                                   : "disabled"
                                             }
                                          >
                                             <div className="display-flex">
                                                <span className="bold-title">
                                                   {t(
                                                      "operations.deconstruction"
                                                   )}
                                                </span>
                                                <div className="selected-option">
                                                   {item.deconstruction_type}
                                                </div>
                                             </div>
                                             {item.deconstruction_type ? (
                                                item.deconstruction_type ==
                                                "provided" ? (
                                                   <div className="sub-description">
                                                      <div>
                                                         {t(
                                                            "passportDetails.deconstructionPlanned"
                                                         )}
                                                      </div>
                                                      <div>{`${t(
                                                         "default.from"
                                                      )} ${moment(
                                                         item.start_date_deconstruction
                                                      ).format(
                                                         "DD/MM/YYYY"
                                                      )} ${t(
                                                         "default.to"
                                                      )} ${moment(
                                                         item.end_date_deconstruction
                                                      ).format(
                                                         "DD/MM/YYYY"
                                                      )}`}</div>
                                                   </div>
                                                ) : (
                                                   <div className="sub-description self-deconst">
                                                      <div className="attention">
                                                         {t(
                                                            "passportDetails.pleaseNote"
                                                         )}
                                                      </div>
                                                      <div>
                                                         {t(
                                                            "passportDetails.selfDeconstructionPossible"
                                                         )}
                                                      </div>
                                                      <div>{`${t(
                                                         "default.between"
                                                      )} ${moment(
                                                         item.self_start_date_deconstruction
                                                      ).format(
                                                         "DD/MM/YYYY"
                                                      )} - ${moment(
                                                         item.self_end_date_deconstruction
                                                      ).format(
                                                         "DD/MM/YYYY"
                                                      )}`}</div>
                                                      <div className="subtitle mt-5">
                                                         {t(
                                                            "passportDetails.customerSupportCall"
                                                         )}
                                                      </div>
                                                   </div>
                                                )
                                             ) : null}
                                          </Col>
                                          <Col span={7}>
                                             <div className="display-flex">
                                                <span className="bold-title">
                                                   {t("operations.logistics")}
                                                </span>
                                                <div className="selected-option">
                                                   {item.logistics_type}
                                                </div>
                                             </div>
                                             {item.logistics_type ==
                                             "shipping" ? (
                                                <div className="sub-description">
                                                   {t(
                                                      "passportDetails.deliveryToAddress"
                                                   )}
                                                </div>
                                             ) : (
                                                <div className="sub-description">
                                                   <div>
                                                      {t(
                                                         "passportDetails.pickupAddress"
                                                      )}
                                                   </div>
                                                   <div className="pickup-address">
                                                      {item?.address}
                                                   </div>
                                                </div>
                                             )}
                                          </Col>
                                       </Row>
                                       {/* )} */}
                                    </div>
                                 );
                              }
                           )}
                     </div>
                     <Row>
                        {orderData && (
                           <Col span={6} offset={18} className="total-price">
                              <div className="display-flex">
                                 <div>{`${totalPieces()} ${
                                    orderDatailsData.data.requestData[0]
                                       ?.amount_unit == "Stück"
                                       ? t("demands.pieces")
                                       : orderDatailsData.data.requestData[0]
                                            ?.amount_unit
                                 }`}</div>
                                 <div>{`${getTotalPrice()} €`}</div>
                              </div>
                              <div className="shipping-cost price display-flex space-between">
                                 <div className="title">
                                    {t("passportDetails.shippingToDelivery")}
                                 </div>
                                 <div>{`${
                                    orderData.services.shipping
                                       ? orderData.services.shipping.toLocaleString()
                                       : 0
                                 } €`}</div>
                              </div>{" "}
                              <div className="sum-price display-flex space-between">
                                 <div>{t("default.total")}</div>
                                 <div>{`${(
                                    getTotalPrice() +
                                    (orderData.services.shipping
                                       ? orderData.services.shipping
                                       : 0)
                                 ).toLocaleString()} €`}</div>
                              </div>
                              <div className="payment-status">
                                 {(orderData.status == "ACCEPTED" ||
                                    orderData.status == "REQUESTED") &&
                                 !orderData.paid &&
                                 !orderData.reserved ? (
                                    <span className="status-tag pink">
                                       {t("default.open").toLocaleLowerCase()}
                                    </span>
                                 ) : null}
                                 {orderData.paid &&
                                 orderData.paid_amount &&
                                 orderData.status != "DELIVERED" ? (
                                    <span className="status-tag green">
                                       {t("demands.paid")}
                                    </span>
                                 ) : null}
                                 {!orderData.paid &&
                                 orderData.reserved &&
                                 orderData.amount_reserved &&
                                 orderData.status != "DELIVERED" ? (
                                    <span className="status-tag green">{`${t(
                                       "demands.depositPaid"
                                    )} (${orderData.paid_amount}€) `}</span>
                                 ) : null}
                                 {orderData.refunded ? (
                                    <span className="status-tag green">
                                       {t("demands.refunded")}
                                    </span>
                                 ) : null}
                              </div>
                           </Col>
                        )}
                     </Row>
                  </Col>
               </Row>
               <Row className="details">
                  <Col span={24}>
                     <div className="display-flex row">
                        <div className="display-flex">
                           <div className="title">{`${t(
                              "passportDetails.destination"
                           )} / ${t("passportDetails.deliveryAddress")}`}</div>
                           <div className="address">
                              {`${deliveryAddress.street}, ${deliveryAddress.zip} ${deliveryAddress.city}`}
                           </div>
                        </div>
                     </div>
                  </Col>
                  <Col span={24}>
                     <div className="display-flex row">
                        <div className="display-flex">
                           <div className="title">{`${t(
                              "passportDetails.invoiceAddress"
                           )}`}</div>
                           <div className="address">
                              {`${invoiceAddress.company}, ${invoiceAddress.street}, ${invoiceAddress.zip} ${invoiceAddress.city}`}
                           </div>
                        </div>
                     </div>
                  </Col>
                  <Col span={24}>
                     <div className="display-flex row">
                        <div className="display-flex">
                           <div className="title">{`${t(
                              "passportDetails.contactDetails"
                           )}`}</div>
                           {contactDetails.email && (
                              <div className="address">
                                 {`${contactDetails.firstName} ${contactDetails.lastName}, ${contactDetails.email}, ${contactDetails.phone}`}
                              </div>
                           )}
                        </div>
                     </div>
                  </Col>
               </Row>
            </div>
         </Spin>
      </Modal>
   );
};
